import React, { Component, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as router from "react-router-dom";
import { Container } from "reactstrap";
// import Pusher from "pusher-js";
import { connect } from "react-redux";
import { logOut } from "../../containers/LoginContainer/action";
import { fetchtandc } from "../../containers/SignUpContainer/action";
import { pusher } from "../../service/pusher";
import {
  /* fetchnotifications, */ unreadnotifications /* ,unshownNotifications */
} from "../../containers/NotificationContainer/action";
import {
  fetchOrdersfromChemist,
  fetchUrgentOrders,
  processednormalOrdersList,
  processedurgentOrdersList,
  deliverednormalOrdersList,
  deliveredurgentOrdersList,
  cancellednormalOrdersList,
  cancelledurgentOrdersList,
  orderReturnList
} from "../../containers/DashboardContainer/action";
import {
  fetchNormalOrders,
  inprogressOrders,
  cancelledOrders,
  deliveredOrders
} from "../../containers/NormalOrdersContainer/action";
import {
  fetchChemistOrders,
  fetchChemistInprogressOrders,
  fetchChemistCompletedOrders,
  fetchChemistCancelledOrders
} from "../../containers/OrdersContainer/action";
import { fetchPurchaseReturns } from "../../containers/PurchaseReturnsContainer/action";
import { fetchExpiryReturns } from "../../containers/ExpiryReturnsContainer/action";
import { getSupportTickets } from "../../containers/SupportContainer/action";
import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
// routes config
import routes from "../../routes";

const DefaultAside = React.lazy(() => import("./DefaultAside"));
const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));

class DefaultLayout extends Component {
  pusherChannel = null;
  pusherChannelName = null;
  orderRefreshTimer = null;

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  componentDidMount() {
    this.subscribeToPusher();
  }

  componentDidUpdate() {
    this.subscribeToPusher();
  }

  getOrderListParams = () => ({
    page: undefined,
    searchKey: "",
    filter: ""
  });

  refreshNewOrders = () => {
    const params = this.getOrderListParams();
    this.props.fetchNormalOrders(params);
    this.props.fetchChemistOrders(params);
  };

  refreshInProgressOrders = () => {
    const params = this.getOrderListParams();
    this.props.inprogressOrders(params);
    this.props.fetchChemistInprogressOrders(params);
  };

  refreshDeliveredOrders = () => {
    const params = this.getOrderListParams();
    this.props.deliveredOrders(params);
    this.props.fetchChemistCompletedOrders(params);
  };

  refreshCancelledOrders = () => {
    const params = this.getOrderListParams();
    this.props.cancelledOrders(params);
    this.props.fetchChemistCancelledOrders(params);
  };

  refreshAllOrderLists = () => {
    this.refreshNewOrders();
    this.refreshInProgressOrders();
    this.refreshDeliveredOrders();
    this.refreshCancelledOrders();
  };

  handleOrderAccepted = () => {
    console.info("Pusher accepted-order event received");
    // "confirm" stays in New; mobile confirmation changes it to "accepted".
    if (
      this.props.location.pathname === "/normal-orders" ||
      this.props.location.pathname === "/orders"
    )
    this.props.processednormalOrdersList();
    this.props.processedurgentOrdersList();
    this.refreshNewOrders();
    this.refreshInProgressOrders();
    this.props.unreadnotifications();
  };

  handleOrderDelivered = () => {
    this.props.deliverednormalOrdersList();
    this.props.deliveredurgentOrdersList();
    this.refreshInProgressOrders();
    this.refreshDeliveredOrders();
    this.props.unreadnotifications();
  };

  handleOrderCancelled = () => {
    this.props.cancellednormalOrdersList();
    this.props.cancelledurgentOrdersList();
    this.refreshNewOrders();
    this.refreshInProgressOrders();
    this.refreshCancelledOrders();
    this.props.unreadnotifications();
  };

  handlePusherEvent = eventName => {
    // Named handlers above deal with the known events. This covers later
    // workflow events (for example confirmation or payment) sent by the API.
    const knownEvents = [
      "chemistDPurchase",
      "chemistDAccept",
      "chemistPOrderAccept",
      "chemistDDelivered",
      "patientCDelivered",
      "shipment",
      "chemistDOrderCancel",
      "patientCOrderCancel",
      "chemistDOrderReject",
      "patientCOrderReject",
      "return",
      "expiryReturn",
      "chemistReturnCancel",
      "chemistExpiryReturnCancel",
      "sprtTcktClosed",
      "sprtTcktInprogress"
    ];

    if (knownEvents.indexOf(eventName) !== -1 || eventName.indexOf("pusher:") === 0) {
      return;
    }

    clearTimeout(this.orderRefreshTimer);
    this.orderRefreshTimer = setTimeout(this.refreshAllOrderLists, 250);
  };

  logPusherEvent = (eventName, data) => {
    console.info("Pusher event received:", eventName, data);
  };

  subscribeToPusher = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const channelName =
      userDetails &&
      (userDetails.role === "employee"
        ? userDetails.distributor
        : userDetails.id);

    // componentDidUpdate runs often. Keep the working subscription unless the
    // authenticated user/channel actually changes.
    if (!channelName || this.pusherChannelName === channelName) {
      return;
    }

    this.unsubscribeFromPusher();
    this.pusherChannel = pusher.subscribe(channelName);
    this.pusherChannelName = channelName;

    console.info("Pusher subscribing to channel:", channelName);

    this.pusherChannel.bind("pusher:subscription_succeeded", () => {
      console.info("Pusher subscription succeeded:", channelName);
    });

    this.pusherChannel.bind("pusher:subscription_error", error => {
      console.error("Pusher subscription failed:", channelName, error);
    });

    this.pusherChannel.bind_global(this.logPusherEvent);

    this.pusherChannel.bind("chemistDPurchase", () => {
      console.info("Pusher new-order event received");
      this.props.fetchOrdersfromChemist();
      this.props.fetchUrgentOrders();
      this.refreshNewOrders();
      this.props.unreadnotifications();
    });

    this.pusherChannel.bind("chemistDAccept", this.handleOrderAccepted);
    this.pusherChannel.bind("chemistPOrderAccept", this.handleOrderAccepted);

    this.pusherChannel.bind("chemistDDelivered", this.handleOrderDelivered);
    this.pusherChannel.bind("patientCDelivered", this.handleOrderDelivered);
    this.pusherChannel.bind("shipment", this.handleOrderDelivered);

    this.pusherChannel.bind("chemistDOrderCancel", this.handleOrderCancelled);
    this.pusherChannel.bind("patientCOrderCancel", this.handleOrderCancelled);
    this.pusherChannel.bind("chemistDOrderReject", this.handleOrderCancelled);
    this.pusherChannel.bind("patientCOrderReject", this.handleOrderCancelled);

    this.pusherChannel.bind("return", () => {
      this.props.orderReturnList();
      this.props.fetchPurchaseReturns({
        page: undefined,
        filter: "",
        searchquery: ""
      });
      this.props.unreadnotifications();
    });

    this.pusherChannel.bind("chemistReturnCancel", () => {
      this.props.orderReturnList();
      this.props.fetchPurchaseReturns({
        page: undefined,
        filter: "",
        searchquery: ""
      });
      this.props.unreadnotifications();
    });

    this.pusherChannel.bind("chemistExpiryReturnCancel", () => {
      this.props.fetchExpiryReturns({
        page: undefined,
        filter: "",
        searchquery: ""
      });
      this.props.unreadnotifications();
    });

    this.pusherChannel.bind("expiryReturn", () => {
      this.props.fetchExpiryReturns({
        page: undefined,
        filter: "",
        searchquery: ""
      });
      this.props.unreadnotifications();
    });

    const refreshSupportTickets = () =>
      this.props.getSupportTickets({ page: undefined, filter: "" });
    this.pusherChannel.bind("sprtTcktClosed", refreshSupportTickets);
    this.pusherChannel.bind("sprtTcktInprogress", refreshSupportTickets);
    this.pusherChannel.bind_global(this.handlePusherEvent);
  };

  unsubscribeFromPusher = () => {
    if (this.pusherChannel) {
      this.pusherChannel.unbind_global(this.logPusherEvent);
      this.pusherChannel.unbind_global(this.handlePusherEvent);
      this.pusherChannel.unbind();
    }
    if (this.pusherChannelName) {
      pusher.unsubscribe(this.pusherChannelName);
    }
    this.pusherChannel = null;
    this.pusherChannelName = null;
    clearTimeout(this.orderRefreshTimer);
    this.orderRefreshTimer = null;
  };

  signOut(e) {
    this.unsubscribeFromPusher();

    e.preventDefault();
    this.props.logoutaction();
    this.props.history.push("/login");
  }

  componentWillUnmount() {
    this.unsubscribeFromPusher();
  }

  render() {
    // console.log(this.props.tnc);
    // console.log(this.props.notifications);
    const user = localStorage.getItem("UserRole");

    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const sidebarNavigation =
      userDetails && userDetails.role === "employee"
        ? {
          ...navigation,
          items: navigation.items.filter((item) => item.name !== "Users"),
        }
        : navigation;
    if (userDetails) {
      return (
        <div className="app">
          <AppHeader fixed>
            <Suspense fallback={this.loading()}>
              <DefaultHeader
                onLogout={e => this.signOut(e)}
                fetchnotifications={this.props.fetchnotifications}
                unreadnotifications={this.props.unreadnotifications}
                /* notifications={this.props.notifications}
              notificationcount={this.props.notificationCount}
              unreadnotificationsdata={this.props.unreadnotificationsdata} */
                unreadnotificationcount={this.props.unreadnotificationcount}
              /* unshownNotifications={this.props.unshownNotifications}
            unshownnotificationsdata={this.props.unshownnotificationsdata}
            unshownnotificationsCount={this.props.unshownnotificationsCount} */
              />
            </Suspense>
          </AppHeader>
          <div className="app-body">
            <AppSidebar fixed display="lg">
              <AppSidebarHeader />
              <AppSidebarForm />
              <Suspense>
                <AppSidebarNav
                  navConfig={sidebarNavigation}
                  router={router}
                />
              </Suspense>
              <AppSidebarFooter />
              <AppSidebarMinimizer />
            </AppSidebar>
            <main className="main">
              {/* <AppBreadcrumb appRoutes={routes} router={router} /> */}
              <Container fluid>
                <Suspense fallback={this.loading()}>
                  <Switch>
                    {routes.map((route, idx) => {
                      return route.component ? (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props =>
                            localStorage.getItem("token") !== null ? (
                              <route.component {...props} />
                            ) : (
                              <Redirect from="/" to="/login" />
                            )
                          }
                        />
                      ) : null;
                    })}
                    <Redirect from="/" to="/dashboard" />
                  </Switch>
                </Suspense>
              </Container>
            </main>
            <AppAside fixed>
              <Suspense fallback={this.loading()}>
                <DefaultAside />
              </Suspense>
            </AppAside>
          </div>
          <div className="footerappdiv">
            <AppFooter
              style={{
                backgroundColor: "#ffff",
                paddingTop: "10px",
                paddingBottom: "10px"
              }}
            >
              <Suspense fallback={this.loading()}>
                <DefaultFooter
                  fetchtandc={this.props.fetchtandc}
                  tnc={this.props.tnc}
                />
              </Suspense>
            </AppFooter>
          </div>
        </div>
      );
    } else return <Redirect to="/login" />
  }
}

function bindAction(dispatch) {
  return {
    logoutaction: () => {
      dispatch(logOut());
    },
    fetchtandc: () => {
      dispatch(fetchtandc());
    },
    /* fetchnotifications:()=>{
      dispatch(fetchnotifications());
    }, */
    unreadnotifications: () => {
      dispatch(unreadnotifications());
    },
    /* unshownNotifications:()=>{
      dispatch(unshownNotifications());
    }, */
    fetchOrdersfromChemist: () => {
      dispatch(fetchOrdersfromChemist());
    },
    fetchUrgentOrders: () => {
      dispatch(fetchUrgentOrders());
    },
    processednormalOrdersList: () => {
      dispatch(processednormalOrdersList());
    },
    processedurgentOrdersList: () => {
      dispatch(processedurgentOrdersList());
    },
    deliverednormalOrdersList: () => {
      dispatch(deliverednormalOrdersList());
    },
    deliveredurgentOrdersList: () => {
      dispatch(deliveredurgentOrdersList());
    },
    cancellednormalOrdersList: () => {
      dispatch(cancellednormalOrdersList());
    },
    cancelledurgentOrdersList: () => {
      dispatch(cancelledurgentOrdersList());
    },
    orderReturnList: () => {
      dispatch(orderReturnList());
    },
    fetchNormalOrders: value => {
      dispatch(fetchNormalOrders(value));
    },
    inprogressOrders: value => {
      dispatch(inprogressOrders(value));
    },
    cancelledOrders: value => {
      dispatch(cancelledOrders(value));
    },
    deliveredOrders: value => {
      dispatch(deliveredOrders(value));
    },
    fetchChemistOrders: value => {
      dispatch(fetchChemistOrders(value));
    },
    fetchChemistInprogressOrders: value => {
      dispatch(fetchChemistInprogressOrders(value));
    },
    fetchChemistCompletedOrders: value => {
      dispatch(fetchChemistCompletedOrders(value));
    },
    fetchChemistCancelledOrders: value => {
      dispatch(fetchChemistCancelledOrders(value));
    },
    fetchPurchaseReturns: value => {
      dispatch(fetchPurchaseReturns(value));
    },
    fetchExpiryReturns: value => {
      dispatch(fetchExpiryReturns(value));
    },
    getSupportTickets: value => {
      dispatch(getSupportTickets(value));
    }
  };
}

function mapStateToProps(state) {
  return {
    tnc: state.SignupReducer.tnc,
    /* notifications:state.NotificationsReducer.notifications,
    notificationCount:state.NotificationsReducer.notificationCount, 
    unreadnotificationsdata:state.NotificationsReducer.unreadnotificationsdata,*/
    unreadnotificationcount: state.NotificationsReducer.unreadnotificationCount
    /* unshownnotificationsdata:state.NotificationsReducer.unshownnotificationsdata,
    unshownnotificationsCount:state.NotificationsReducer.unshownnotificationsCount */
  };
}

export default connect(
  mapStateToProps,
  bindAction
)(DefaultLayout);
